var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.682954 0C0.305782 0 0 0.388062 0 0.866724C0 1.34539 0.305782 1.73345 0.682954 1.73345H13.317C13.6942 1.73345 14 1.34539 14 0.866724C14 0.388062 13.6942 0 13.317 0H0.682954ZM0.682954 5.63328C0.305782 5.63328 0 6.02134 0 6.5C0 6.97866 0.305782 7.36672 0.682954 7.36672H13.317C13.6942 7.36672 14 6.97866 14 6.5C14 6.02134 13.6942 5.63328 13.317 5.63328H0.682954ZM0 12.1333C0 11.6546 0.305782 11.2666 0.682954 11.2666H13.317C13.6942 11.2666 14 11.6546 14 12.1333C14 12.6119 13.6942 13 13.317 13H0.682954C0.305782 13 0 12.6119 0 12.1333Z",
    fill: "#485057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.99eac9cb0886db5c342dfc48d8b6fb1c.svg";
export { ForwardRef as ReactComponent };